import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate, useLocation  } from 'react-router-dom';

import API_URL from './api/config';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';


function TreeOrderPayment() {
  
 const navigate = useNavigate();
 const location = useLocation();
  
  const queryParams = new URLSearchParams(location.search);
  const verifyCode = queryParams.get("verifyCode");


  const { data: treeOrderDetails, isLoadingTb, isErrorTb } = useQuery({
    queryKey: ["treeOrderDetails", verifyCode], // include in cache key
    queryFn: () =>
      axios
        .get(`${API_URL}/tree-order-check-code-api?verifyCode=${verifyCode}`, { 
          withCredentials: true 
        })
        .then((response) => response.data),
    enabled: !!verifyCode, //only run if verifyCode exists
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: "always",
  refetchOnWindowFocus: "always",
  });




  if (isLoadingTb) return <div className="loadingspinnerDiv">
  <div className="loadingspinner"></div>
</div>;
  if (isErrorTb) return <p>Error fetching data</p>;

  return (
    

    <div className='main-wrapper'>
          <div className='content container-fluid'>


          {isLoadingTb && <p>Loading order details...</p>}
{isErrorTb && <p className="text-danger">Error loading order details</p>}

{treeOrderDetails ? (

<div className="d-flex justify-content-center align-items-center mt-4">
<div className="col-md-8 col-lg-6">
  <div className="card ">
    <div className="card-header text-white text-center" style={{background: '#75B437', borderRadius: '0px', }}>
      <h5 className="mb-0">Order Summary</h5>
    </div>

    <div className="card-body">
      <p className="lead">
        Hello <strong>{treeOrderDetails.full_names}</strong>, kindly proceed
        to complete your order.
      </p>

      <hr />

      <div className="row mb-2">
        <div className="col-6 fw-bold">Header:</div>
        <div className="col-6">{treeOrderDetails.header}</div>
      </div>

      <div className="row mb-2">
        <div className="col-6 fw-bold">Tree Size:</div>
        <div className="col-6">{treeOrderDetails.tree_size_name}</div>
      </div>

      <div className="row mb-2">
        <div className="col-6 fw-bold">No. of Copies:</div>
        <div className="col-6">{treeOrderDetails.number_of_copies}</div>
      </div>

      <div className="row mb-2">
        <div className="col-6 fw-bold">Background:</div>
        <div className="col-6">
          <span
            style={{
              display: "inline-block",
              width: "25px",
              height: "25px",
              backgroundColor: treeOrderDetails.background_color,
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          ></span>
        </div>
      </div>

      <div className="row mb-2">
        <div className="col-6 fw-bold">Names:</div>
        <div className="col-6">{treeOrderDetails.full_names}</div>
      </div>

      <div className="row mb-2">
        <div className="col-6 fw-bold">Phone:</div>
        <div className="col-6">{treeOrderDetails.phone_number}</div>
      </div>

      <div className="row mb-2">
        <div className="col-6 fw-bold">Email:</div>
        <div className="col-6">{treeOrderDetails.email}</div>
      </div>

      <div className="row mb-2">
        <div className="col-6 fw-bold">Pickup Location:</div>
        <div className="col-6">{treeOrderDetails.pickup_location_name}</div>
      </div>

      <div className="row mb-2">
        <div className="col-6 fw-bold">Total Amount:</div>
        <div className="col-6 text-success fw-bold">
          KES {treeOrderDetails.total_amount}
        </div>
      </div>

      <div className="row mb-2">
        <div className="col-6 fw-bold">Date:</div>
        <div className="col-6">
          {new Date(treeOrderDetails.date_time).toLocaleString()}
        </div>
      </div>
    </div>

    <div className="card-footer text-center bg-light">
      <button className="btn btn-primary me-2x"
      onClick={() =>
        navigate("/tree-order-payment-now", {
          state: { verifyCode: verifyCode },
        })
      }
        >Proceed to Payment</button>
      
    </div>
  </div>
</div>
</div>


) : (

  <div
  className="d-flex justify-content-center align-items-center" >
    <div
    className="card shadow-lg text-center p-5 mt-4"
    style={{ maxWidth: "500px", borderRadius: "0px" }} >
    {/* Warning Icon */}
    <div className="mb-4">
      <div
        className="d-inline-flex align-items-center justify-content-center rounded-circle"
        style={{
          width: "70px",
          height: "70px",
          backgroundColor: "#ffe6e6",
        }}
      >
         
        <i className="fa fa-exclamation-triangle text-danger fs-2"></i>
      </div>
    </div>

    {/* Title */}
    <h3 className="fw-bold text-danger">Link Expired</h3>

    {/* Message */}
    <p className="text-muted mt-3">
      Sorry, the link has expired. Kindly resend the notification to continue.
    </p>

    </div>
  </div>
)}
    

  

<div className='row mt-4' style={{marginTop: '5%'}}></div>


        </div>
        </div>
  );
}

export default TreeOrderPayment;
